/**
 * @generated SignedSource<<44e96551102ce719916679439850d7e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpButton_query$data = {
  readonly jira: {
    readonly jsonUserProperty: {
      readonly jsonValue: AGG$JSON | null;
    } | null;
  } | null;
  readonly " $fragmentType": "HelpButton_query";
};
export type HelpButton_query$key = {
  readonly " $data"?: HelpButton_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"HelpButton_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "HelpButton_query",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "propertyKey",
              "value": "help_button_ui_state"
            }
          ],
          "concreteType": "JiraEntityPropertyJSON",
          "kind": "LinkedField",
          "name": "jsonUserProperty",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jsonValue"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "b16f7c262a9e67dafab211133bb8bc5e";

export default node;
